const TickMark = () => (
  <svg
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
    className="h-3 w-3 inline-flex text-green-600 fill-current"
  >
    <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
  </svg>
);

const CrossMark = () => (
  <svg
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
    className="h-3 w-3 inline-flex text-gray-400 fill-current"
  >
    <path d="M10.72 1.293a1 1 0 00-1.415 0L6.012 4.586 2.72 1.293a1 1 0 00-1.414 1.414L4.598 6 1.305 9.293a1 1 0 101.414 1.414l3.293-3.293 3.293 3.293a1 1 0 001.414-1.414L7.426 6l3.293-3.293a1 1 0 000-1.414z" />
  </svg>
);

const VsAutoML = () => (
  <>
    <div className="my-3 py-3">
      Daisho is built with{" "}
      <span className="italic font-semibold">BUSINESS USERS</span> in mind, and
      informed by our experiences as both producers and consumers of insights.
      Hence, Daisho does everything AutoML does, while also:
      <ul className="mx-2 px-2 py-2">
        <li>1. Focusing on automated hypotheses discovery, and</li>
        <li>
          2. Orienting all problem statements around{" "}
          <span className="italic font-semibold">business lens (recipes)</span>{" "}
          instead of algorithms.
        </li>
      </ul>
    </div>
    <div>
      <table className="table-fixed">
        <thead>
          <tr>
            <th className="w-1/2 px-4 py-2"></th>
            <th className="w-1/6 px-4 py-2">Daisho</th>
            <th className="w-1/6 px-4 py-2">DataRobot, H2O.ai, etc.</th>
            <th className="w-1/6 px-4 py-2">Azure, Google, Amazon</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b">
            <td className="px-4 py-2 text-left" colSpan={4}>
              <p className="font-bold">Usability and Design</p>
              <p className="italic font-gray-700">
                How easy is it to use? And what's needed to use?
              </p>
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Complete No-Code</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <CrossMark />
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Can be used by Business Users</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <CrossMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <CrossMark />
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Recipes for BUSINESS problems</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <CrossMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <CrossMark />
            </td>
          </tr>

          <tr className="border-b">
            <td className="px-4 py-2 text-left" colSpan={4}>
              <p className="font-bold">Hypotheses Discovery</p>
              <p className="italic font-gray-700">
                More than 80% of a data-science project is just hypotheses
                discovery.
              </p>
            </td>
          </tr>

          <tr>
            <td className="w-1/2 px-4 py-2">Build Hypotheses</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <p>
                <TickMark />
              </p>
              <p>Automatic</p>
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <p>
                <CrossMark />
              </p>
              <p>Manual Coding</p>
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <p>
                <CrossMark />
              </p>
              <p>Manual Coding</p>
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Extensive Data Preparation</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <CrossMark />
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Test and Filter Hypotheses</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <p>
                <TickMark />
              </p>
              <p>Automatic</p>
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <p>
                <CrossMark />
              </p>
              <p>Manual: off-platform</p>
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <p>
                <CrossMark />
              </p>
              <p>Manual: off-platform</p>
            </td>
          </tr>
          <tr className="border-b">
            <td className="px-4 py-2 text-left" colSpan={4}>
              <p className="font-bold">Model Building</p>
            </td>
          </tr>

          <tr>
            <td className="w-1/2 px-4 py-2">Extensive Range of Algorithms</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <p>
                <TickMark />
              </p>
              <p>Curated for Business Usage</p>
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <p>
                <TickMark />
              </p>
              <p>Everything</p>
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <p>
                <TickMark />
              </p>
              <p>Users' Choice</p>
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Single-Click </td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Automated Feature Engineering </td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
          </tr>
          <tr>
            <td className="w-1/2 px-4 py-2">Hyper-Parameter Tuning</td>
            <td className="w-1/6 px-4 py-2 text-center align-top h-3">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
            <td className="w-1/6 px-4 py-2 text-center align-top">
              <TickMark />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </>
);

export default VsAutoML;
